import React, { useState } from 'react';
import { Modal } from 'antd';
import { get } from 'lodash';
import { withApollo } from 'react-apollo';
import { bool, func, object } from 'prop-types';
import DELETE_PERMISSION from '../../graphql/deleteABMPermission';
import { Text, FlexContainer, Row, Icon, Button, IconContainer } from '../../common';

export const ModalDelete = ({ visible, toggleModal, permission, client }) => {
    const [loading, setLoading] = useState(false);

    const handleDelete = () => {
        setLoading(true);
        client.mutate({
            mutation: DELETE_PERMISSION,
            variables: {
                input: {
                    roleName: get(permission, 'roleName')
                }
            },
            refetchQueries: ['getResources']
        }).then(() => {
            setLoading(false);
            toggleModal();
        }).catch(() => {
            setLoading(false);
        });
    }

    return (
        <Modal
            closable={false}
            visible={visible}
            footer={null}
            destroyOnClose
        >
            <FlexContainer align='center' direction='column'>
                <IconContainer color='#f38630'>
                    <Icon name='trash' color='#ffffff' size={46.8} />
                </IconContainer>
                <FlexContainer mY={30} direction='column' align='center'>
                    <Row justify='center'>
                        <Text text={<>Eliminarás permiso <strong>{get(permission, 'name')}</strong></>} />
                    </Row>
                    <Row>
                        <Text centered text='¿Estás seguro?' />
                    </Row>
                </FlexContainer>
                <FlexContainer justify='flex-end' style={{ width: '100%' }}>
                    <Button
                        link
                        text='btn.action.cancel'
                        style={{ width: '100px' }}
                        onClick={() => toggleModal()}
                    />
                    <Button
                        disabled={loading}
                        loading={loading}
                        text='btn.action.confirm'
                        style={{ width: '100px' }}
                        onClick={handleDelete}
                    />
                </FlexContainer>
            </FlexContainer>
        </Modal>
    );
};

ModalDelete.propTypes = {
    visible: bool,
    toggleModal: func,
    permission: object,
    client: object
};

export default withApollo(ModalDelete);
